const SEVERITIES_MAP = {
    low: 'icon-jfui-xray-low yellow',
    medium: 'icon-jfui-xray-medium orange',
    high: 'icon-jfui-xray-high red',
    unknown: 'icon-jfui-xray-not-scanned ',
    information: 'icon-screw',
    pendingscan: 'icon-screw ',
    'scanned-noissues': 'icon-jfui-xray-ok green',
    nodata: '',
    errorstate: 'icon-jfui-xray-error red'
};


export default class XraySeverityStatusComponent {
    constructor() {
        this.template = require('./xray.status.view.html');
        this.controller = XrayStatusController;
        this.bindings = {
            status: '<'
        };
    }
}

XraySeverityStatusComponent.META = {
    name: 'xraySeverityStatus'
};


class XrayStatusController {
    constructor() {

    }

    $onInit() {
        this.status = this.status || 'No data';
        this.normalizedStatus = this.status.replace(/\s/g, '').toLowerCase();
        this.severityClass = SEVERITIES_MAP[this.normalizedStatus];
        this.capitalStatus = this.status ? this.status.charAt(0).toUpperCase() + this.status.slice(1) : '';
    }

}


XrayStatusController.$inject = [];




// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/xrayServerityStatus/xray.severity.status.component.js